<template>
  <van-tabbar v-if="show" v-model="active" :border="true" active-color="#7e5678" inactive-color="#979799">
    <van-tabbar-item v-for="(k, key) in item" :key="key" :to="k.router" replace>
      <span style="white-space: nowrap;">{{ $t(k.title) }}</span>
      <template #icon="props">
        <img :alt="k.title" :src="props.active ? k.icon.active : k.icon.noactive"/>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      item: [
        {
          router: '/Home',
          title: 'tabbar.首页',
          icon: {
            active: '/img/footer/首页选中.jpg',
            noactive: '/img/footer/首页未选中.jpg'
          }
        },
        {
          router: '/Game',
          title: 'tabbar.预约',
          icon: {
            active: '/img/footer/预约选中.jpg',
            noactive: '/img/footer/预约未选中.jpg'
          }
        },
        {
          router: '/Choose',
          title: 'tabbar.地区选择',
          icon: {
            active: '/img/footer/beauty.52660ad1.png',
            noactive: '/img/footer/beauty.52660ad1.png'
          }
        },
        {
          router: '/Video',
          title: 'tabbar.视频',
          icon: {
            active: '/img/footer/视频选中.jpg',
            noactive: '/img/footer/视频未选中.jpg'
          }
        },
        {
          router: '/Mine',
          title: 'tabbar.我的',
          icon: {
            active: '/img/footer/我的选中.jpg',
            noactive: '/img/footer/我的未选中.jpg'
          }
        }
      ]
    };
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == 'home') {
        this.active = 0;
        this.show = true;
      } else if (to.name == 'game') {
        this.active = 1;
        this.show = true;
      } else if (to.name == 'choose') {
        this.active = 2;
        this.show = true;
      } else if (to.name == 'video') {
        this.active = 3;
        this.show = true;
      } else if (to.name == 'mine') {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    }
  },
  created() {
    if (this.$route.name == 'home') {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == 'game') {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == 'choose') {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == 'video') {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == 'mine') {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  }
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 75px;

.van-tabbar {
  height: @tabbar-height;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  
  /* PC端适配：保持移动端样式，限制宽度并居中 */
  @media (min-width: 768px) {
    max-width: 430px;
    width: 430px;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
  }
}

.van-tabbar-item__icon {
  margin-bottom: 5px;
  
  img {
    height: @tabbar-img;
    width: auto;
    display: block;
    margin: 0 auto;
  }
}

.van-tabbar-item {
  font-size: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
}

.van-tabbar-item__text {
  margin-top: 5px;
  font-size: 26px;
}

.tui {
  width: 4rem;
  margin-top: -10.333vw;
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}

[class*='van-hairline']::after {
  border: none !important;
}

/* PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733) */
@media (min-width: 768px) {
  .van-tabbar {
    height: 63px; /* 110px * 0.5733 ≈ 63px */
  }

  .van-tabbar-item__icon img {
    height: 43px; /* 75px * 0.5733 ≈ 43px */
    width: auto;
  }

  .van-tabbar-item {
    font-size: 15px; /* 26px * 0.5733 ≈ 15px */
  }

  .van-tabbar-item__text {
    font-size: 15px; /* 26px * 0.5733 ≈ 15px */
  }

  .tui {
    width: 2.3rem; /* 4rem * 0.5733 ≈ 2.3rem */
    margin-top: -44px; /* -77.5px * 0.5733 ≈ -44px */
    border: 6px solid white; /* 10px * 0.5733 ≈ 6px */
  }
}

/* 确保底部导航栏的样式正确 */
::v-deep .van-tabbar {
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  
  @media (min-width: 768px) {
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }
}

::v-deep .van-tabbar-item {
  flex: 1;
}

::v-deep .van-tabbar-item__icon {
  font-size: 0;
}
</style>
